export class Enum {
  key: number;
  value: number;

  constructor(key, value) {
    this.key = key;
    this.value = +value;
  }
}
